// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"6f21f141","390":"bdac8e86","700":"322ac20a"}[chunkId] + ".chunk.css";
};